import {
  SR_API_ACTION_HOUSEHOLD_GET_APPLICATIONS,
} from 'api/actionTypes';

// Loads the current user's household applications
export default async function getApplications({ state, apiClient }, { userId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_APPLICATIONS,
    state: state,
    payload: {
      userId,
    },
    onSuccess(householdApplications) {
      state.set(['householdApplications'], householdApplications);
      return householdApplications;
    },
  });
}
